import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gkjmb5v7z: FaireProductEntity = {
  token: "p_6gkjmb5v7z",
  type: "product",
  name: "Kerosene Jade Lighter",
  brandToken: "b_94e8mnvjlr",
  brandName: "Curated Basics",
  imageUrl:
    "https://cdn.faire.com/fastly/345c41e591e0a6ff47050ead95272351fdc33909b3650bdd6594c5f4f1ba1307.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39ef04da7865214eaf3cad3a78f7c021bd1b93d959b0076829463a2c0a4f710e.png",
    "https://cdn.faire.com/fastly/09d87edc9a5f7f3b5046cadb05b5bb6382332f9df47d24de50b79e535a4e2ba6.png",
  ],
  priceDollars: 42,
  description:
    'Kerosene Jade Lighter\n\n100% solid brass, brushed finish\n2 1/8" x 2"\n\nPlease expect variations in different pattern and color of natural jade\nCompatible with most lighter fluid brands Ronson, Zippos etc. \nBottom plate is removable for easy changing wick and cotton filling.',
  tags: [],
  msrpDollars: 84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:27.573Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
